import { MutableRefObject, useRef, useState } from 'react'

const useTimer = (time: number) => {
  const Ref: MutableRefObject<null | NodeJS.Timer> = useRef(null)

  const [timer, setTimer] = useState(0)

  const getTimeRemaining = (e: any) => {
    const total = Date.parse(e) - Date.parse(new Date().toString())
    const seconds = Math.floor((total / 1000) % 60)
    return {
      total,
      seconds
    }
  }

  const startTimer = (e: any) => {
    let { total, seconds } = getTimeRemaining(e)
    if (total >= 0) {
      setTimer(seconds)
    }
  }

  const clearTimer = (e: any) => {
    setTimer(time)

    if (Ref.current) clearInterval(Ref.current)
    const id = setInterval(() => {
      startTimer(e)
    }, 1000)
    Ref.current = id
  }

  const getDeadTime = () => {
    let deadline = new Date()

    deadline.setSeconds(deadline.getSeconds() + time)
    return deadline
  }

  const resetTimer = () => {
    clearTimer(getDeadTime())
  }

  return {
    timer,
    resetTimer
  }
}

export default useTimer
